import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import avatar from '../../common/helpers/avatar';
import Select from '../../common/components/Select';

export default class PuzzleTipModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.attrs = vnode.attrs;
  }

  className() {
    return `Modal--small dl-modal-small puzzle-tip-modal tip${this.attrs.index}`;
  }

  title() {
    return;
  }

  content() {
    return (
      <div className="puzzle-tip-box">
        {this.attrs.index === 0 && (
          <img
            src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameyongqi/btm-qp2.webp`}
          ></img>
        )}
        {this.attrs.index === 5 && (
          <img
            src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamelove/btm-tips-gz.webp`}
          ></img>
        )}
      </div>
    );
  }
}
